import { type ModalOpenResult, useModalStore } from '@tix/modal'

import { getTimezone } from '@/helpers/environment'

import CalendarPickerContent, { type CalendarPickerContentProps } from './CalendarPickerContent.vue'

type ApiDate = { date?: string; status?: string }

type OpenCalendarPickerModalProps = {
  dates: ApiDate[]
  title?: string
  onSelect: CalendarPickerContentProps['onSelect']
}

export function openCalendarPickerModal({
  dates,
  title = 'Choose a date',
  onSelect: handleSelect,
}: OpenCalendarPickerModalProps): ModalOpenResult {
  const modal = useModalStore()
  const modalName = 'pick-date-calendar'

  return modal.open({
    component: CalendarPickerContent,
    name: modalName,
    title,
    size: 'xl',
    dismissible: true,
    closeable: true,
    props: {
      dates,
      timezone: getTimezone(),
      onSelect: (date: string) => {
        handleSelect?.(date)
        modal.close(modalName)
      },
    },
  })
}
